(() => {
  const initialize = root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-light-form]');
    const input = form.querySelector('[name="quantity"]');
    const submit = form.querySelector('[type="submit"]');
    const label = submit.querySelector('[data-submit-label]');
    const status = root.querySelector('[data-light-status]');
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    const step = Number(input.step) || 1;
    const unitPrice = Number(root.dataset.price);
    const units = Number(root.dataset.units);
    let busy = false;
    const money = cents => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: root.dataset.currency
        }).format(cents / 100);
      } catch {
        return (cents / 100).toFixed(2) + ' ' + root.dataset.currency;
      }
    };
    const update = () => {
      const quantity = Number(input.value);
      const valid = Number.isSafeInteger(quantity) && input.checkValidity();
      root.querySelector('[data-quantity-minus]').disabled = busy || quantity <= min;
      root.querySelector('[data-quantity-plus]').disabled = busy || quantity >= max;
      root.querySelector('[data-order-total]').textContent = valid ? money(quantity * unitPrice) : '—';
      root.querySelector('[data-unit-count]').textContent = valid
        ? root.dataset.countLabel.replace('[count]', String(quantity * units)) : '';
    };
    root.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const current = Number(input.value);
        const base = Number.isSafeInteger(current) ? current : min;
        input.value = Math.min(max, Math.max(min, base + Number(button.dataset.quantityChange) * step));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    input.addEventListener('input', update);
    root.querySelectorAll('[data-light-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        const main = root.querySelector('[data-light-main]');
        main.src = button.dataset.src;
        main.removeAttribute('srcset');
        main.alt = button.dataset.alt;
        root.querySelectorAll('[data-light-thumb]').forEach(other => {
          other.setAttribute('aria-pressed', String(other === button));
        });
        root.querySelector('[data-gallery-caption]').textContent = button.dataset.caption;
      });
    });
    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (busy || submit.disabled || !form.reportValidity()) return;
      const body = new FormData(form);
      if (!body.get('id')) return;
      busy = true;
      submit.disabled = true;
      input.readOnly = true;
      form.setAttribute('aria-busy', 'true');
      label.textContent = root.dataset.adding;
      status.textContent = '';
      update();
      try {
        const response = await fetch(root.dataset.addUrl, {
          method: 'POST', headers: { Accept: 'application/json' },
          credentials: 'same-origin', body
        });
        const result = await response.json();
        if (!response.ok || Number(result.status) >= 400) {
          throw new Error(result.description || result.message || root.dataset.error);
        }
        status.textContent = root.dataset.added;
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = error instanceof SyntaxError || error instanceof TypeError
          ? root.dataset.networkError : (error.message || root.dataset.error);
        busy = false;
        submit.disabled = false;
        input.readOnly = false;
        label.textContent = root.dataset.addLabel;
        form.removeAttribute('aria-busy');
        update();
      }
    });
    update();
  };
  const scan = scope => scope.querySelectorAll('[data-lavelle-lighting]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
